import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
const SidebarLink = ({ label, icon = '', iconActive = '', isActive, isCollapsed = false, href, mainStyle = false, testId = '', isButton = false, onClick })=>{
    const pathname = usePathname();
    const isNewPath = (path)=>{
        return path.includes('en-gb') || path.includes('de-de');
    };
    const isAnchor = ()=>{
        const pagePath = isNewPath(pathname);
        const linkPath = isNewPath(href !== null && href !== void 0 ? href : '');
        return pagePath !== linkPath;
    };
    const linkContent = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            mainStyle ? /*#__PURE__*/ _jsx(Image, {
                src: isActive ? iconActive : icon,
                alt: label,
                width: 24,
                height: 24,
                className: iconStyle
            }) : isActive && /*#__PURE__*/ _jsx("div", {
                className: bulletPointContainer,
                children: /*#__PURE__*/ _jsx("div", {
                    className: bulletPointStyle
                })
            }),
            !isCollapsed && /*#__PURE__*/ _jsx("span", {
                className: `${mainStyle ? textStyle : secondTextStyle} ${isActive ? activeTextStyle : inactiveTextStyle}`,
                children: label
            })
        ]
    });
    const defaultSidebarLinkStyle = `${mainStyle ? linkStyle : secondLinkStyle} ${isActive ? activeLinkStyle : ''}`;
    if (isButton) {
        return /*#__PURE__*/ _jsx("button", {
            className: defaultSidebarLinkStyle,
            "data-testid": `${testId}-Sidebar-Link`,
            onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(),
            children: linkContent
        }, label);
    }
    if (isAnchor()) {
        return /*#__PURE__*/ _jsx("a", {
            href: href !== null && href !== void 0 ? href : '/',
            className: defaultSidebarLinkStyle,
            "data-testid": `${testId}-Sidebar-Link`,
            onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(),
            children: linkContent
        }, label);
    }
    return /*#__PURE__*/ _jsx(Link, {
        href: href !== null && href !== void 0 ? href : '/',
        className: defaultSidebarLinkStyle,
        "data-testid": `${testId}-Sidebar-Link`,
        onClick: ()=>onClick === null || onClick === void 0 ? void 0 : onClick(),
        children: linkContent
    }, label);
};
export default SidebarLink;
const linkStyle = 'flex p-4 cursor-pointer rounded-lg hover:bg-lightGrey4 mobile:flex-col mobile:justify-center mobile:items-center mobile:p-1 mobile:basis-24 mobile:gap-1';
const activeLinkStyle = 'bg-lightGrey5';
const iconStyle = 'w-6 h-6 text-transparent';
const textStyle = 'mobile:text-sm overflow-hidden text-ellipsis mobile:overflow-visible mobile:leading-5 leading-6 ml-4 mobile:ml-0 mobile:w-[4.688rem] mobile:text-center mobile:w-full mobile:tracking-tight';
const activeTextStyle = 'text-primaryColor font-bold';
const inactiveTextStyle = 'font-normal';
const secondLinkStyle = 'flex w-48 mobile:w-full p-2 border-lightGrey5 rounded-lg border cursor-pointer gap-2 hover:bg-lightGrey4 hover:border-lightGrey4 mobile:text-sm mobile:items-center';
const secondTextStyle = 'overflow-hidden text-ellipsis';
const bulletPointContainer = 'flex h-6 items-center';
const bulletPointStyle = 'flex shrink-0 bg-primaryColor w-2 h-2 rounded-full';
